export enum Quantity {
  all = 'All',
  four = 4,
  eight = 8,
  sixteen = 16,
}
